import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { IAppValidator } from './validator';

export const cnpjErrorKey = 'cpfErrorKey';
const invalidMessage = { [cnpjErrorKey]: 'CNPJ inválido' };
const FORMATTED_CNPJ = /^[\dA-Za-z.\-\/]+$/;
const NORMALIZED_CNPJ = /^[A-Z0-9]{14}$/;
const INVALID_LEGACY_REPEATED = /^(\d)\1{13}$/;

export class CnpjValidator implements IAppValidator {
  execute(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors => {
      const value = control.value;
      if (!value) {
        return invalidMessage;
      }

      const isString = typeof value === 'string';
      const validTypes = isString || Number.isInteger(value) || Array.isArray(value);

      if (!validTypes) {
        return invalidMessage;
      }

      if (isString) {
        if (value.length > 18) {
          return invalidMessage;
        }

        if (!FORMATTED_CNPJ.test(value)) {
          return invalidMessage;
        }
      }

      const normalized = CnpjValidator.normalize(value.toString());
      if (!NORMALIZED_CNPJ.test(normalized)) {
        return invalidMessage;
      }

      if (INVALID_LEGACY_REPEATED.test(normalized)) {
        return invalidMessage;
      }

      const base = normalized.substring(0, 12);
      const expectedDv1 = CnpjValidator.parseDigit(normalized.charAt(12));
      const expectedDv2 = CnpjValidator.parseDigit(normalized.charAt(13));

      if (expectedDv1 === null || expectedDv2 === null) {
        return invalidMessage;
      }

      const calculatedDv1 = CnpjValidator.calculateDigit(base, CnpjValidator.PESOS_DV1);
      const calculatedDv2 = CnpjValidator.calculateDigit(base + calculatedDv1, CnpjValidator.PESOS_DV2);

      return calculatedDv1 === expectedDv1 && calculatedDv2 === expectedDv2 ? {} : invalidMessage;
    };
  }

  static normalize(cnpj: string): string {
    return cnpj.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
  }

  private static readonly PESOS_DV1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  private static readonly PESOS_DV2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  private static calculateDigit(value: string, weights: number[]): number {
    let sum = 0;

    for (let i = 0; i < value.length; i++) {
      sum += CnpjValidator.toCalculationValue(value.charAt(i)) * weights[i];
    }

    const remainder = sum % 11;
    return remainder < 2 ? 0 : 11 - remainder;
  }

  private static toCalculationValue(char: string): number {
    return char.charCodeAt(0) - 48;
  }

  private static parseDigit(char: string): number | null {
    if (char >= '0' && char <= '9') {
      return char.charCodeAt(0) - 48;
    }
    return null;
  }
}

export const cnpjValidator = new CnpjValidator();
